jQuery('.select-items div').click(function() { 
  var text = jQuery(this).text();

  jQuery('#caseStudiesFilterSelect').each(function() {
    jQuery(this).val(text).change();
  })
});

jQuery('#caseStudiesFilterSelect').on('change', function(e) {
    e.preventDefault();

    var category = jQuery(this).val();

    jQuery('.ajax-loader').show();
    jQuery('.ajax-loader .logo').addClass();
    // jQuery('.ajax-loader .logo path').addClass('loading-color');
    jQuery('.ajax-container').css({'opacity':'0'});
        jQuery.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                action: 'filter_case_studies',
                category: category,
            },
            success: function(res) {
                jQuery('#blogGallery').slick('unslick');
                jQuery('.ajax-container').html(res);
                jQuery('.ajax-loader').hide();
                jQuery('.ajax-loader .logo').removeClass('loading');
                // jQuery('.ajax-loader .logo path').removeClass('loading-color');
                jQuery('.ajax-container').css({'opacity':'1'});
                
                var slickOpts = {
                    slidesToShow: 3.2,
                    rows: 2,
                    slidesToScroll: 3,
                    easing: 'swing',
                    speed: 700,
                    dots: true,
                    infinite: false,
                    arrows: true,
                    customPaging: function(slick,index) {
                      if (index < 10) {
                        return '<a>0' + (index + 1) + '</a>';
                      } else {
                        return '<a>' + (index + 1) + '</a>';
                      }
                    },
                    prevArrow: jQuery('.gallery-prev'),
                    nextArrow: jQuery('.next-arrow'),
                    appendDots: jQuery('#galleryDots'),
                    responsive: [
                      {
                        breakpoint: 1000,
                        settings: {
                          slidesToShow: 2.2,
                          slidesToScroll: 2,
                        }
                      },
                      {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 1.2,
                          slidesToScroll: 1,
                          dots: false,
                          rows: 1,
                        }
                      }
                    ]
                  };
                  // Init slick carousel
                jQuery('#blogGallery').slick(slickOpts);
            }
        })
    jQuery('#offset').val(1);
});